
import { v4 as uuidv4 } from "uuid";
import { 
  AbilityScores, 
  // AdaptationInstance, 
  AlternateConditionFeature, 
  FeatureAncestry, 
  Bonus, 
  CharacterAbility, 
  CharacterAction, 
  CharacterAdvantage, 
  CharacterASIBaseFeature, 
  CharacterExtraEffects, 
  CharacterFeature, 
  CharacterFeatureBase, 
  CharacterProficiency, 
  CharacterResourceWithUsed, 
  CharacterRoll, 
  CharacterSense, 
  CharacterSlot, 
  CharacterSpell, 
  CreatureHP, 
  DamageMultiplierSimple, 
  GreaterAdvantage, 
  HitDiceWithUsed, 
  MinimumRoll, 
  Modifier, 
  RangeBonus, 
  Reroll, 
  SkillAbilityOverrideFeature, 
  SpellModifier, 
  UpgradableNumber,
  SizeOptions,
  CharacterFeatureSource,
  HitDice,
  CharacterResource,
  Character,
  BasicCreatureInstance,
  SummonInstance,
  ComplexCreatureInstance,
  TransformInstance,
} from "@dndModels";
import { CreatureType, DamageType, SizeType } from "@dndModels/Types";
import { Subscription } from "@models/Subscription";
// import DataUtilities from "../../utilities/common_utilities";

export class CharacterResourceHolder {
  true_id = "";
  hp: CreatureHP = new CreatureHP();
  hit_dice: HitDiceWithUsed[] = [];
  resources: CharacterResourceWithUsed[] = [];
  slots: CharacterSlot[] = [];
  special_resources: { ability_true_id: string, used: number }[] = [];

  constructor(obj?: any) {
    if (obj) {
      this.true_id = obj.true_id ? obj.true_id : "";
      // console.log(obj);
      this.hp = obj.hp ? new CreatureHP(obj.hp) : new CreatureHP();
      this.hit_dice = obj.hit_dice ? obj.hit_dice.map((o: any) => new HitDiceWithUsed(o)) : [];
      this.resources = obj.resources ? obj.resources.map((o: any) => new CharacterResourceWithUsed(o)) : [];
      this.slots = obj.slots ? obj.slots.map((o: any) => new CharacterSlot(o)) : [];
      this.special_resources = obj.special_resources ? obj.special_resources : [];
    }
  }

  getSpecialResourceUsed(ability_true_id: string) {
    const special_resource = this.special_resources.find(o => o.ability_true_id === ability_true_id);
    if (special_resource) {
      return special_resource.used;
    }
    return 0;
  }

  setSpecialResourceUsed(ability_true_id: string, used: number) {
    let special_resource = this.special_resources.find(o => o.ability_true_id === ability_true_id);
    if (special_resource) {
      special_resource.used = used;
    } else {
      special_resource = { ability_true_id, used };
      this.special_resources.push(special_resource);
    }
  }

  addToSpecialResourceUsed(ability_true_id: string, add: number) {
    let special_resource = this.special_resources.find(o => o.ability_true_id === ability_true_id);
    if (special_resource) {
      special_resource.used += add;
    } else {
      special_resource = { ability_true_id, used: add };
      this.special_resources.push(special_resource);
    }
  }

  getCharacterResource(resource_id: string) {
    return this.resources.find(o => o.type_id === resource_id);
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      hp: this.hp.toDBObj(),
      hit_dice: this.hit_dice.map(o => o.toDBObj()),
      resources: this.resources.map(o => o.toDBObj()),
      slots: this.slots.map(o => o.toDBObj()),
      special_resources: this.special_resources,
    };
  }

  clone() {
    const clone = new CharacterResourceHolder();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CharacterResourceHolder): void {
    this.true_id = copyMe.true_id;
    this.hp = copyMe.hp.clone();
    this.hit_dice = copyMe.hit_dice.map(o => o.clone());
    this.resources = copyMe.resources.map(o => o.clone());
    this.slots = copyMe.slots.map(o => o.clone());
    this.special_resources = copyMe.special_resources.map(o => { return {...o}; });
  }
}
export class MaxResourceHolder {
  true_id = "";
  hp = 0;
  hit_dice: HitDice[] = [];
  resources: CharacterResource[] = [];
  special_resources: { ability_true_id: string, used: number }[] = [];

  constructor(obj?: any) {
    if (obj) {
      this.true_id = obj.true_id ? obj.true_id : "";
      // console.log(obj);
      this.hp = obj.hp ? obj.hp : 0;
      this.hit_dice = obj.hit_dice ? obj.hit_dice.map((o: any) => new HitDice(o)) : [];
      this.resources = obj.resources ? obj.resources.map((o: any) => new CharacterResource(o)) : [];
      this.special_resources = obj.special_resources ? obj.special_resources : [];
    }
  }

  getSpecialResourceUsed(ability_true_id: string) {
    const special_resource = this.special_resources.find(o => o.ability_true_id === ability_true_id);
    if (special_resource) {
      return special_resource.used;
    }
    return 0;
  }

  setSpecialResourceUsed(ability_true_id: string, used: number) {
    let special_resource = this.special_resources.find(o => o.ability_true_id === ability_true_id);
    if (special_resource) {
      special_resource.used = used;
    } else {
      special_resource = { ability_true_id, used };
      this.special_resources.push(special_resource);
    }
  }

  addToSpecialResourceUsed(ability_true_id: string, add: number) {
    let special_resource = this.special_resources.find(o => o.ability_true_id === ability_true_id);
    if (special_resource) {
      special_resource.used += add;
    } else {
      special_resource = { ability_true_id, used: add };
      this.special_resources.push(special_resource);
    }
  }

  getCharacterResource(resource_id: string) {
    return this.resources.find(o => o.type_id === resource_id);
  }

  toDBObj(): any {
    return {
      true_id: this.true_id,
      hp: this.hp,
      hit_dice: this.hit_dice.map(o => o.toDBObj()),
      resources: this.resources.map(o => o.toDBObj()),
      special_resources: this.special_resources,
    };
  }

  clone() {
    const clone = new MaxResourceHolder();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: MaxResourceHolder): void {
    this.true_id = copyMe.true_id;
    this.hp = copyMe.hp;
    this.hit_dice = copyMe.hit_dice.map(o => o.clone());
    this.resources = copyMe.resources.map(o => o.clone());
    this.special_resources = copyMe.special_resources.map(o => { return {...o}; });
  }
}

// https://stackoverflow.com/questions/50020982/how-to-subscribe-to-object-changes

// let validator = {
//   set: function(target, key, value) {
//       console.log(`The property ${key} has been updated with ${value}`);
//       return true;
//   }
// };
// let store = new Proxy({}, validator);
// store.a = 'hello';
// // console => The property a has been updated with hello

export type SubscriptionType = "Resources" | "Modal Closed" | "Recalculated" | "Recalculate" | "Items" | 
  "Bastion" | "Minions" | "Reload" | "Skill" | "" | "Display" | "Transform" | "Spells" | "Spells Recalculated" | 
  "Receivables" | "Stats" | "Logout" | "Character" | "Campaign" | "Actions";

export class CharacterSubscriptionHolder {
  private eventMap: { [subscription_type: string]: Subscription[] } = {};

  private get onResourcesChanged()        { return this.getOrInit("Resources"); }
  private get onSkillsChanged()           { return this.getOrInit("Skill"); }
  private get onDisplayChanged()          { return this.getOrInit("Display"); }
  private get onRecalculated()            { return this.getOrInit("Recalculated"); }
  private get onMinionsChanged()          { return this.getOrInit("Minions"); }
  private get onReload()                  { return this.getOrInit("Reload"); }
  private get onCharacterChanged()        { return this.getOrInit("Character"); }
  private get onCampaignChanged()         { return this.getOrInit("Campaign"); }
  private get onTransform()               { return this.getOrInit("Transform"); }
  private get onSpellsChanged()           { return this.getOrInit("Spells"); }
  private get onSpellsRecalculated()      { return this.getOrInit("Spells Recalculated"); }
  private get onItemsChanged()            { return this.getOrInit("Items"); }
  private get onBastionChanged()          { return this.getOrInit("Bastion"); }
  private get onReceivablesChanged()      { return this.getOrInit("Receivables"); }
  private get onStatsChanged()            { return this.getOrInit("Stats"); }
  private get onModalClosed()             { return this.getOrInit("Modal Closed"); }
  private get onActionsChanged()          { return this.getOrInit("Actions"); }
  private get onRecalculate()             { return this.getOrInit("Recalculate"); }

  feedTo?: CharacterSubscriptionHolder;

  private getOrInit(key: SubscriptionType): Subscription[] {
    if (!this.eventMap[key]) {
      this.eventMap[key] = [];
    }
    return this.eventMap[key];
  }

  characterChanged(from_recalc: boolean = false) {
    this.eventMap.onAny = this.onCharacterChanged.filter(o => o.ref.current);
    for (const sub of this.onCharacterChanged) {
      sub.method("Character", from_recalc);
    }
    if (this.feedTo) { // We only want to feed through a few types of subscriptions
      this.feedTo.characterChanged();
    }
  }

  campaignChanged(from_recalc: boolean = false) {
    this.eventMap.onAny = this.onCampaignChanged.filter(o => o.ref.current);
    for (const sub of this.onCampaignChanged) {
      sub.method("Campaign", from_recalc);
    }
  }

  resourcesChanged(from_recalc: boolean = false) {
    // console.log(this.eventMap.onResourcesChanged.length);
    this.eventMap.onResourcesChanged = this.onResourcesChanged.filter(o => o.ref.current);
    // console.log(this.eventMap.onResourcesChanged.length);
    // this.eventMap.onResourcesChanged = this.onResourcesChanged.filter(o => o.subscribed);
    // console.log(this.eventMap.onResourcesChanged.length);
    for (const sub of this.onResourcesChanged) {
      sub.method("Resources", from_recalc);
    }
  }

  statsChanged(from_recalc: boolean = false) {
    this.eventMap.onStatsChanged = this.onStatsChanged.filter(o => o.ref.current);
    for (const sub of this.onStatsChanged) {
      sub.method("Stats", from_recalc);
    }
  }

  skillsChanged(from_recalc: boolean = false) {
    this.eventMap.onSkillsChanged = this.onSkillsChanged.filter(o => o.ref.current);
    for (const sub of this.onSkillsChanged) {
      sub.method("Skill", from_recalc);
    }
  }

  modalClosed(from_recalc: boolean = false) {
    this.eventMap.onModalClosed = this.onModalClosed.filter(o => o.ref.current);
    for (const sub of this.onModalClosed) {
      sub.method("Modal Closed", from_recalc);
    }
  }

  itemsChanged(from_recalc: boolean = false) {
    this.eventMap.onItemsChanged = this.onItemsChanged.filter(o => o.ref.current);
    for (const sub of this.onItemsChanged) {
      sub.method("Items", from_recalc);
    }
  }

  bastionChanged(from_recalc: boolean = false) {
    this.eventMap.onBastionChanged = this.onBastionChanged.filter(o => o.ref.current);
    for (const sub of this.onBastionChanged) {
      sub.method("Bastion", from_recalc);
    }
  }

  displayChanged(from_recalc: boolean = false) {
    this.eventMap.onDisplayChanged = this.onDisplayChanged.filter(o => o.ref.current);
    for (const sub of this.onDisplayChanged) {
      sub.method("Display", from_recalc);
    }
  }

  minionsChanged(from_recalc: boolean = false) {
    this.eventMap.onMinionsChanged = this.onMinionsChanged.filter(o => o.ref.current);
    for (const sub of this.onMinionsChanged) {
      sub.method("Minions", from_recalc);
    }
    if (this.feedTo) { // We only want to feed through a few types of subscriptions
      this.feedTo.minionsChanged();
    }
  }

  transformed(from_recalc: boolean = false) {
    // console.log("transformed");
    this.eventMap.onTransform = this.onTransform.filter(o => o.ref.current);
    for (const sub of this.onTransform) {
      sub.method("Transform", from_recalc);
    }
  }

  spellsChanged(from_recalc: boolean = false) {
    this.eventMap.onSpellsChanged = this.onSpellsChanged.filter(o => o.ref.current);
    for (const sub of this.onSpellsChanged) {
      sub.method("Spells", from_recalc);
    }
  }

  spellsRecalculated(from_recalc: boolean = false) {
    this.eventMap.onSpellsRecalculated = this.onSpellsRecalculated.filter(o => o.ref.current);
    for (const sub of this.onSpellsRecalculated) {
      sub.method("Spells Recalculated", from_recalc);
    }
  }

  actionsChanged(from_recalc: boolean = false) {
    this.eventMap.onActionsChagned = this.onActionsChanged.filter(o => o.ref.current);
    for (const sub of this.onActionsChanged) {
      sub.method("Actions", from_recalc);
    }
  }

  recalculated() {
    this.eventMap.onRecalculated = this.onRecalculated.filter(o => o.ref.current);
    for (const sub of this.onRecalculated) {
      sub.method("Recalculated", true);
    }
    this.resourcesChanged(true);
  }

  recalculate() {
    this.eventMap.onRecalculate = this.onRecalculate.filter(o => o.ref.current);
    for (const sub of this.onRecalculate) {
      sub.method("Recalculate", false);
    }
    if (this.feedTo) { // We only want to feed through a few types of subscriptions
      this.feedTo.recalculate();
    }
  }

  receivablesChanged(from_recalc: boolean = false) {
    this.eventMap.onReceivablesChanged = this.onReceivablesChanged.filter(o => o.ref.current);
    for (const sub of this.onReceivablesChanged) {
      sub.method("Receivables", from_recalc);
    }
  }

  reload() {
    this.eventMap.onReload = this.onReload.filter(o => o.ref.current);
    for (const sub of this.onReload) {
      sub.method("Reload", false);
    }
    if (this.feedTo) { // We only want to feed through a few types of subscriptions
      this.feedTo.reload();
    }
  }

  subscribe(to: SubscriptionType, ref: React.MutableRefObject<boolean>, method: (triggered_by: SubscriptionType, from_recalc: boolean) => void) {
    const true_id = uuidv4().toString();
    const existing = this.getOrInit(to).find(o => o.ref === ref);
    if (!existing) {
      this.eventMap[to].push({ method, ref, true_id });
    }
    return true_id;
  }
}

export type CreatureInstance = BasicCreatureInstance | SummonInstance | ComplexCreatureInstance;

export type CharacterSheetInterface = Character | CreatureInstance | TransformInstance;

export class CharacterAbilityModifier {
  source_type = "";
  source_id = "";
  ancestries: FeatureAncestry[] = [];
  source_name = "";
  modifier: SpellModifier = new SpellModifier();
  char_feature: CharacterFeature = new CharacterFeature();

  constructor(obj?: any) {
    if (obj) {
      this.source_type = obj.source_type ? obj.source_type : "";
      this.source_id = obj.source_id ? obj.source_id : "";
      this.ancestries = obj.ancestries ? obj.ancestries : [];
      this.source_name = obj.source_name ? obj.source_name : "";
      this.modifier = obj.modifier ? (obj.modifier instanceof SpellModifier ? obj.modifier : new SpellModifier(obj.modifier)) : new SpellModifier();
      this.char_feature = obj.char_feature ? (obj.char_feature instanceof CharacterFeature ? obj.char_feature : new CharacterFeature(obj.char_feature)) : undefined;
    }
  }
  
  toDBObj() {
    return {
      source_type: this.source_type,
      source_id: this.source_id,
      ancestries: this.ancestries,
      source_name: this.source_name,
      modifier: this.modifier.toDBObj(),
      char_feature: this.char_feature?.toDBObj()??undefined
    };
  }

  copy(copyMe: CharacterAbilityModifier) {
    this.source_type = copyMe.source_type;
    this.source_id = copyMe.source_id;
    this.ancestries = copyMe.ancestries.map(o => { return {...o}; });
    this.source_name = copyMe.source_name;
    this.modifier = copyMe.modifier;
  }

  clone() {
    const clone = new CharacterAbilityModifier();
    clone.copy(this);
    return clone;
  }
}

/**
 * I'm working on a massive overhaul of how I'm handling characters. 
 * It's going to be a massive change to repopulating, 
 * but I hope that it will speed it up and lessen the bugs that happen in it.
 * 
 * The idea is that I'm going to separate Characters 
 * (and similar things like Creature Instances)
 * into 3 parts: Spirit, Mind, and Body.
 * 
 * Spirit is the core of the character. 
 * It's the stuff you decide when creating the character, when leveling up, taking a long rest, etc.
 * It includes your CFSs, as well as your choices on all of those (including your prepared spells), and your minions.
 * It also includes any customizations you've got.
 * The Spirit is the main part of what gets saved to the db.
 * 
 * Mind is the part based on the Spirit that really gets interacted with in the char sheet on a regular basis.
 * It has collections of feature bases, features, and actions, as well as your max capacity for any resources.
 * Repopulating is basically building the Mind from the Spirit.
 * 
 * Body is the part that holds your resources: HP, Hit Dice, Spell Slots, 
 * and everything else that gets used up and refreshed. It also holds things like Advantage and Inspiration.
 * Changes to the Body should never trigger changes to the Spirit or Mind, 
 * but as the Spirit changes the Mind changes, and this can in turn change the Body.
 * The Body is likewise saved to the db.
 * 
 * Spirit will be stored in the db in multiple pieces.
 * Body is small enough to safely be a single piece.
 * The main Character class (or whatever similar thing is using it)
 * will manage the saving and applying of pieces, but they can use the functions here to aid in it.
 */
export interface Spirit {
  base_size: SizeType; // Options come from CFSs, but this is where the selected one is stored.
  base_ability_scores: AbilityScores;
  char_feature_sources: CharacterFeatureSource[];
}

/**
 * This is all stuff built from the Spirit, be it from features or from customizations.
 */
export interface Mind {
  // Features
  char_feature_bases: CharacterFeatureBase[]; 
  features: CharacterFeature[]; 
  resource_features: CharacterFeature[];
  ability_features: CharacterFeature[]; 
  characteristic_features: CharacterFeature[]; 
  asi_features: CharacterFeature[];
  ability_score_features: { cf: CharacterFeature, casibf: CharacterASIBaseFeature }[]; 
  language_features: CharacterFeature[]; 
  proficiency_features: CharacterFeature[]; 
  modifier_features: CharacterFeature[]; 
  spell_modifier_features: CharacterFeature[];
  disable_action_features: CharacterFeature[];
  attack_upgrades: CharacterFeature[];
  weapon_damage_upgrades: CharacterFeature[];
  extra_effects_features: CharacterFeature[];
  extra_effects: CharacterExtraEffects[]; 
  light_attack_add_damage_mods: CharacterFeature[]; 
  source_features: CharacterFeature[];
  sense_features: CharacterFeature[];
  start_equipment_features: CharacterFeature[];
  misc_features: CharacterFeature[]; 
  spellcasting_features: CharacterFeature[];
  alternate_condition_features: AlternateConditionFeature[];
  ignore_stealth_disadvantage_for_armor_type_ids: string[];
  transform_upgrades: CharacterFeature[]; 

  // Size
  base_size: SizeType; // copied from Spirit
  size_modifier: number; 
  overriding_size: SizeType;
  size_option_features: SizeOptions[];
  size_options: SizeType[];
  use_size: SizeType; // calculated from the above ones. This is the one that gets used the most.
  
  // Ability Scores
  base_ability_scores: AbilityScores; // copied from Spirit
  max_ability_scores: AbilityScores; 
  bonus_ability_score_modifiers: AbilityScores;
  override_ability_scores: AbilityScores; 
  current_ability_scores: AbilityScores; // calculated from the above ones.

  // Carrying Capacity
  size_bonus_for_carrying: number;
  carrying_capacity_mult: number; 
  max_carrying_capacity: number; // calculated from use_size, current_ability_scores, and the above.
  
  // Attributes
  character_level: number;
  proficiency_modifier: number; // get based on character_level
  override_creature_type?: CreatureType;
  creature_type: CreatureType;
  languages_known: string[];
  speed: {
    walk: number,
    swim: number,
    climb: number,
    fly: number,
    burrow: number
  };
  senses: CharacterSense[]; 
  damage_multipliers: DamageMultiplierSimple[]; 
  formula_values: { [key: string]: number };
  string_hash: { [key: string]: string };
  upgradable_hash: { [key: string]: UpgradableNumber };
  // AC
  base_armor_class: number;
  max_ac_dex_bonus_for_med_armor: number; 
  armor_class: number; 
  // Initiative
  initiative_modifier: number;
  initiative_bonuses: Bonus[];
  initiative_check: CharacterRoll;
  // Saves
  saving_throw_bonuses: Bonus[]; 
  saving_throw_profs: { [ability_score: string]: number };
  saving_throws: { 
    [ability_score: string]: CharacterRoll
  };
  // Checks
  jack_of_all_trades: boolean;
  proficiencies: CharacterProficiency[]; 
  skill_proficiencies: CharacterProficiency[]; // gets, filtering from the above one
  tool_proficiencies: CharacterProficiency[];
  special_proficiencies: CharacterProficiency[];
  weapon_proficiencies: CharacterProficiency[];
  armor_proficiencies: CharacterProficiency[];
  saving_throw_proficiencies: CharacterProficiency[];
  expertises: CharacterProficiency[];
  skill_ability_overrides: SkillAbilityOverrideFeature[]; 
  ability_checks: { 
    STR: CharacterRoll, 
    DEX: CharacterRoll, 
    CON: CharacterRoll, 
    INT: CharacterRoll, 
    WIS: CharacterRoll, 
    CHA: CharacterRoll 
  };
  skill_checks: { skill_id: string, skill_check: CharacterRoll }[]; 
  passive_bonuses: { // Once this overhaul is done, rename this to just passives
    perception: number,
    insight: number,
    investigation: number
  };
  // Advantage
  advantages: CharacterAdvantage[];
  greater_advantages: GreaterAdvantage[];
  // Attacks
  extra_attacks: number; 
  // Once the rest of the overhaul is done, I want to put these into their own object, and have that go here.
  unarmed_strike_scores: string[]; 
  unarmed_strike_bonus_action: boolean; 
  unarmed_strike_damage_types: DamageType[]; 
  unarmed_strike_size: number; 
  unarmed_strike_count: number; 
  unarmed_strike_add_attack_to_dmg: boolean;
  
  // Modifiers
  table_modifiers: Modifier[];
  spell_modifiers: CharacterAbilityModifier[];
  
  // Bonuses
  range_bonuses: RangeBonus[];
  rerolls: Reroll[];
  minimum_rolls: MinimumRoll[];
  attack_bonuses: Bonus[];
  damage_bonuses: Bonus[];
  check_bonuses: Bonus[];
  
  // Actions
  ritual_only: CharacterSpell[];
  abilities: CharacterAbility[];
  spell_as_abilities: CharacterAbility[];
  actions: CharacterAction[];

  // For Creature Transforms
  spellcasting_ability: string;
  spell_dc: UpgradableNumber;
  spell_attack: UpgradableNumber;
  non_magic_attack: UpgradableNumber;
  magic_dmg_bonus: UpgradableNumber;
  non_magic_dmg_bonus: UpgradableNumber;
}

export interface Body {
  name: string;
  image_url: string; 
  // It's also going to have characteristics, notes, etc.

  resource_holder: CharacterResourceHolder;
  hp: CreatureHP;
  hit_dice: HitDiceWithUsed[]; 
  resources: CharacterResourceWithUsed[];
  slots: CharacterSlot[]; 
  use_slots: CharacterSlot[]; 
}
